import account from "../account";

const accountKey = `preferences`;
const preferences = {
    set: {
        storage: (newStorage: object): boolean => account.set.key(accountKey, newStorage),
        key: function(key: string, value?: any): boolean {
            if (`${key}`.length === 0) {
                return false;
            }

            const storageAgers = preferences.get() || {};
            if (
                typeof storageAgers === `object`
                && storageAgers !== null
            ) {
                storageAgers[key] = value;

                return this.storage(storageAgers);
            }

            return false;
        },
        keys: function(object: object): void {
            const storageAgers = preferences.get() || {};
            if (
                typeof storageAgers !== `object`
                || storageAgers === null
            ) {
                return;
            }

            this.storage(
                {
                    ...storageAgers,
                    ...object
                }
            );
        },
    },
    remove: {
        key : (key: string): void => {
            if (`${key}`.length === 0) {
                return;
            }

            const storageAgers = preferences.get();
            if (
                typeof storageAgers === `object`
                && storageAgers !== null
                && storageAgers.hasOwnProperty(key)
            ) {
                storageAgers[key] = undefined;
                delete storageAgers[key];
                preferences.set.storage(storageAgers);
            }
        },
        keys: (...keys: string[]): void => {
            const storageAgers = preferences.get();
            if (
                typeof storageAgers !== `object`
                || storageAgers === null
            ) {
                return;
            }

            keys.forEach(
                key => {
                    if (storageAgers.hasOwnProperty(key)) {
                        storageAgers[key] = undefined;
                        delete storageAgers[key];
                    }
                }
            );

            preferences.set.storage(storageAgers);
        }
    },
    clear : (): void => account.remove.key(accountKey),
    get: (key?: string) => {
        const storageAgers = account.get(accountKey);
        if (!key) {
            return storageAgers;
        }

        return typeof storageAgers === `object` && storageAgers !== null && storageAgers.hasOwnProperty(key)
            ? storageAgers[key]
            : undefined;
    },

    dateTime: (format: string = `Y-m-d H:i:s`): void => {
        preferences.set.key(`dateTimeFormat`, format);
    },
};

export default preferences;